import request from '@/utils/superagent'
import handleAPIException from '@/utils/handleAPIException'
import APIS from '../apis'

export default {
  new: async function(cloudNoticeInfo) {
    return new Promise((resolve, reject) => {
      request(APIS.NOTICE.NEW.method, APIS.NOTICE.NEW.path())
        .send(cloudNoticeInfo)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  update: async function(cloudNoticeInfo) {
    return new Promise((resolve, reject) => {
      request(APIS.NOTICE.UPDATE.method, APIS.NOTICE.UPDATE.path())
        .send(cloudNoticeInfo)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  getAll: async function() {
    return new Promise((resolve, reject) => {
      request(APIS.NOTICE.GET_ALL.method, APIS.NOTICE.GET_ALL.path()).end(
        (err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        }
      )
    })
  },
  getOne: async function() {
    return new Promise((resolve, reject) => {
      request(APIS.NOTICE.GET_ONE.method, APIS.NOTICE.GET_ONE.path()).end(
        (err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Notice.js